// Google Analytics 4 用ユーティリティ
// より詳細な分析が必要になった場合に使用

// ページビュー追跡
export const trackPageView = (url, title) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-9CHQ792H78', {
      page_title: title,
      page_location: url,
    });
  }
};

// イベント追跡
export const trackEvent = (action, category, label, value) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// カスタムイベント例
export const trackPosterCreation = (posterId) => {
  trackEvent('create_poster', 'engagement', 'poster_created', posterId);
};

export const trackLogin = (method) => {
  trackEvent('login', 'authentication', method);
};

export const trackSignup = (method) => {
  trackEvent('sign_up', 'authentication', method);
};

export const trackFavorite = (posterId) => {
  trackEvent('add_favorite', 'engagement', 'poster_favorited', posterId);
};

// コメント作成（新規作成時のみ。「あなたへの問いかけ」経由かどうかを区別する）
export const trackCommentCreation = (docId, fromPersonalizedQuestion) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'create_comment', {
      event_category: 'engagement',
      event_label: fromPersonalizedQuestion ? 'from_personalized_question' : 'normal',
      from_personalized_question: Boolean(fromPersonalizedQuestion),
      doc_id: docId,
    });
  }
};